import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMegaphone = () => {
  return (
    <g>
      <path d="M15.25 1a.75.75 0 0 1 .75.75v12.49a.75.75 0 0 1-1.5 0l-.001-1.091-3.76-.816v1.917a.75.75 0 0 1-.81.747l-.1-.014-4.995-1.085a.75.75 0 0 1-.584-.628l-.007-.104-.001-2.243-.909-.197a.75.75 0 0 1-.55-.49l-1.672.914a.75.75 0 0 1-1.104-.553L0 10.493V5.497a.75.75 0 0 1 1.016-.702l.095.044 1.671.915a.75.75 0 0 1 .551-.49l11.166-2.425V1.75a.75.75 0 0 1 .75-.75h.001zM5.743 11.248v1.313l3.496.759-.001-1.313-3.495-.759zm8.506-6.82L4.243 6.6v2.789l10.006 2.172V4.427zM1.499 6.76v2.469l1.242-.679V7.438L1.5 6.76z" />
    </g>
  );
};

export default withIcon(IconMegaphone);
